angular.module('smarttableutilities', ['ui.select'])

	.filter('supplierFilter', function () {
		return function (list, term) {
			var out = [];
			angular.forEach(list, function (item) {
				if (item.supplierName.toUpperCase().indexOf(term.toUpperCase()) >= 0) {
					out.push(item);
				} else if (item.supplierCode.toUpperCase().indexOf(term.toUpperCase()) >= 0) {
					out.push(item);
				}
			});
			return out;
		};
	})

	.config(function ($provide) {
		$provide.decorator('uiSelectDirective', function ($delegate, $parse) {
			var directive = $delegate[0],
				preCompile = directive.compile;

			directive.compile = function compile() {
				var link = preCompile.apply(this, arguments);

				return function (scope, element, attrs, controller) {
					link.apply(this, arguments);

					var $select = controller[0];

					if (attrs.uiSelectOnOpen || attrs.uiSelectOnClose) {
						$select.onOpenCallback = $parse(attrs.uiSelectOnOpen);
						$select.onCloseCallback = $parse(attrs.uiSelectOnClose);
						scope.$watch('$select.open', function (newV) {
							if (newV) {
								$select.onOpenCallback(scope, {
									$model: $select.parserResult.modelMapper(scope, {})
								});
							} else {
								$select.onCloseCallback(scope, {
									$model: $select.parserResult.modelMapper(scope, {})
								});
							}
						});
					}
				};
			};

			return $delegate;
		});
	})

	.directive('compile', ['$compile', function ($compile) {
		return function (scope, element, attrs) {
			scope.$watch(
				function (scope) {
					return scope.$eval(attrs.compile);
				},
				function (value) {
					element.html(value);
					$compile(element.contents())(scope);
				}
			);
		};
	}])

	.directive('ngBlurOnEnter', function () {
		return function (scope, element, attrs) {
			element.bind('keydown keypress', function (event) {
				if (event.which === 13) {
					scope.$apply(function () {
						element[0].blur();
					});
					event.preventDefault();
				}
			});
		};
	})

	.directive('pageSelect', function () {
		return {
			restrict: 'E',
			template: '<input class="form-control currentPageInput" ng-model="inputPage" ng-blur="selectPage(inputPage)" ng-blur-on-enter>',
			link: function (scope, element, attrs) {
				scope.$watch('currentPage', function (c) {
					scope.inputPage = c;
				});
			}
		};
	})

	.directive('resizable', function () {
		return {
			restrict: 'A',
			scope: {
				callback: '&onResize'
			},
			link: function postLink(scope, elem, attrs) {
				var scrollLeftValue = 0;
				elem.resizable({
					handles: 'e'
				});
				elem.on('resizestart', function (evt, ui) {
					var table = jQuery('table.smartTable');
					scrollLeftValue = jQuery('.tableBodyDivClass').scrollLeft();
					table.floatThead('destroy');
					jQuery('.tableBodyDivClass').scrollLeft(scrollLeftValue);
				});
				elem.on('resizestop', function (evt, ui) {
					var width = ui.element.outerWidth();
					var resizeId = ui.element.attr('id');
					var otherId = resizeId.substring(6);
					jQuery('#' + otherId + '0').outerWidth(width);
					var table = jQuery('table.smartTable');
					table.floatThead({
						scrollContainer: function (table) {
							return table.closest('.smartTableGrid');
						}
					});
					// latest version of floatThead is off by 2px in their calculation of width
					setTimeout(function() {
						var tbWidth = jQuery('.floatThead-container').width();
						jQuery('.floatThead-container').width(tbWidth - 2);
					}, 0);
					jQuery('.tableBodyDivClass').scrollLeft(scrollLeftValue);
					if (scope.callback) {
						scope.callback(evt, ui);
					}
				});
			}
		};
	})

	.directive('resizableTest', function () {
		return {
			restrict: 'A',
			scope: {
				callback: '&onResize'
			},
			link: function postLink(scope, elem, attrs) {
				var scrollLeftValue = 0;
				elem.resizable({
					handles: 'e'
				});
				elem.on('resizestart', function (evt, ui) {
					if (ui.element.hasClass('main-table-headers')) {
						var parent = jQuery('#mainTableHideScroll')[0];
						var child = jQuery('#mainTableScroll')[0];
						parent.style.width = 'inherit';
						child.style.width = 'inherit';

						jQuery('#mainTable')[0].style.width = jQuery('#mainTable').outerWidth() + 'px';
						// Make container huge so table can expands
						jQuery('.main-table-container')[0].style.width = '9001px';
					} else if (ui.element.hasClass('pinned-table-headers')) {
						var parent = jQuery('#pinnedTableHideScroll')[0];
						var child = jQuery('#pinnedTableScroll')[0];
						parent.style.width = 'inherit';
						child.style.width = 'inherit';

						jQuery('#pinnedTable')[0].style.width = jQuery('#pinnedTable').outerWidth() + 'px';
					} else if (ui.element.hasClass('group-table-headers')) {
						var parent = jQuery('#groupTableHideScroll')[0];
						var child = jQuery('#groupTableScroll')[0];
						parent.style.width = 'inherit';
						child.style.width = 'inherit';

						jQuery('#groupTable')[0].style.width = jQuery('#groupTable').outerWidth() + 'px';
						// Make container huge so table can expand
						jQuery('.group-table-container')[0].style.width = '9001px';
					}
				});
				elem.on('resizestop', function (evt, ui) {
					if (ui.element.hasClass('main-table-headers')) {
						// Get width of header row
						var headers = jQuery('#mainTableHeaders .header');
						var headerRowWidth = 0;
						for (var i = 0; i < headers.length; i++) {
							headerRowWidth += jQuery(headers[i]).outerWidth();
						}

						// Hide scrollbar
						var parent = jQuery('#mainTableHideScroll')[0];
						var child = jQuery('#mainTableScroll')[0];
						var extraPadding = child.offsetWidth - child.clientWidth;
						parent.style.width = headerRowWidth + 'px';
						child.style.width = headerRowWidth + extraPadding + 'px';

						// Set container back to size of table
						jQuery('#mainTable')[0].style.width = headerRowWidth + 'px';
						jQuery('.main-table-container')[0].style.width = headerRowWidth + 'px';
					} else if (ui.element.hasClass('pinned-table-headers')) {
						// Get width of header row
						var headers = jQuery('#pinnedTableHeaders .header');
						var headerRowWidth = 0;
						for (var i = 0; i < headers.length; i++) {
							headerRowWidth += jQuery(headers[i]).outerWidth();
						}

						// Hide Scroll Bar
						var parent = jQuery('#pinnedTableHideScroll')[0];
						var child = jQuery('#pinnedTableScroll')[0];
						var extraPadding = child.offsetWidth - child.clientWidth;
						parent.style.width = headerRowWidth + 'px';
						child.style.width = headerRowWidth + extraPadding + 'px';

						// Set container back to size of table
						jQuery('#pinnedTable')[0].style.width = headerRowWidth + 'px';
					} else if (ui.element.hasClass('group-table-headers')) {
						// Get width of header row
						var headers = jQuery('#groupTableHeaders .header');
						var headerRowWidth = 0;
						for (var i = 0; i < headers.length; i++) {
							headerRowWidth += jQuery(headers[i]).outerWidth();
						}

						// Hide Scroll Bar
						var parent = jQuery('#groupTableHideScroll')[0];
						var child = jQuery('#groupTableScroll')[0];
						var extraPadding = child.offsetWidth - child.clientWidth;
						parent.style.width = headerRowWidth + 'px';
						child.style.width = headerRowWidth + extraPadding + 'px';

						// Set container back to size of table
						jQuery('#groupTable')[0].style.width = headerRowWidth + 'px';
						jQuery('.group-table-container')[0].style.width = headerRowWidth + 'px';
						jQuery('.group-header').outerWidth(headerRowWidth);
					}

					if (scope.callback) {
						scope.callback(evt, ui);
					}
				});
			}
		};
	})

	.directive('resizeTable', function ($window, $timeout, $rootScope, $experiments, oldNavMargin, oldNavMarginCollapsed) {
		return {
			link: function (scope, element, attr) {
				var w = angular.element($window);
				jQuery(window).off('resize');
				w.off('resize');
				var tableName = attr.tableName;
				var embeddedBodyOffsetWhenOpen = oldNavMargin;
				var embeddedBodyOffsetWhenClosed = oldNavMarginCollapsed;
				w.bind('resize', function () {
					resizeTable();
					scope.$apply();
				});

				function resizeTable() {
					var navExists = jQuery('.sidebarCollapsible').length != 0;
					var navOpen = jQuery('.sidebarCollapsible.sidebarCollapsed').length == 0;
					var hasEndOfLifeBanner = jQuery('.browserIE11EndOfLifeBanner.show').length !== 0;

					var navOffset = 0;
					if (navExists && navOpen) {
						navOffset = 180;
					}
					var bOffset = scope.navProps.hideSubNav ? embeddedBodyOffsetWhenClosed : embeddedBodyOffsetWhenOpen;
					jQuery('.embeddedBody').css('margin-left', bOffset);
					var wWidth = jQuery(window).width();
					jQuery('.embeddedBody').innerWidth(wWidth - bOffset);
					var navHeight = 54;
					if (hasEndOfLifeBanner) {
						navHeight += 60;
					}
					var newHeight = jQuery(window).height() - navHeight - 41 - 40 - 42 - 8;

					if (jQuery('.userDetails') && jQuery('.userDetails').length) {
						newHeight = jQuery(window).height() - navHeight - jQuery('.userDetails').height() - 40;
					}

					if (jQuery('.titleWithViews') && jQuery('.titleWithViews').length) {
						newHeight = newHeight - 12;
					}
					if (jQuery('.tableAttached') && jQuery('.tableAttached').length) {
						newHeight = newHeight - 8;
					}
					if (jQuery('.tab-content .smartTable') && jQuery('.tab-content .smartTable').length) {
						newHeight = newHeight - 88;
						if (jQuery('.tab-content .actionsButton') && jQuery('.tab-content .actionsButton').length) {
							newHeight = newHeight - 40;
						}
						if (jQuery('.filtersContainer') && jQuery('.filtersContainer').length) {
							newHeight = newHeight + 44;
						}
					}
					var hasExtraText = jQuery('.extraText') && jQuery('.extraText').length;
					if (hasExtraText) {
						newHeight = newHeight - 40 + 32 + 18;
					}
					var paddingOffset = 32;
					jQuery('.smartTableGrid').css('width', (jQuery(window).width() - paddingOffset - navOffset) + 'px');
					jQuery('.smartTableGrid').css('height', newHeight + 'px');
					jQuery('#' + tableName + 'HeaderDiv').css('height', 56 + 'px');
					var width = jQuery('.row').width() - jQuery('.filters.dropdown').width() -
						jQuery('.searchBlock').width();
					var width2 = jQuery('.row').width() - jQuery('.searchBlock').width() - 40;
					var totalFilters = jQuery('.filtersContainer .currentFilters').length;
					var minWidthOfFilters = totalFilters * 54 + jQuery('.filters.dropdown').width();
					jQuery('.searchBlock').css('top', 15);
					if (width2 < minWidthOfFilters) {
						jQuery('.filtersContainer .row').css('height', 88);
						jQuery('.filtersContainer').css('height', 88);
						jQuery('.filterRowWidthAdjuster').css('width', width);
					} else {
						if (!hasExtraText) {
							jQuery('.filtersContainer .row').css('height', 44);
							jQuery('.filtersContainer').css('height', 44);
						} else {
							jQuery('.filtersContainer').css('height', 0);
						}
						jQuery('.filterRowWidthAdjuster').css('width', '100%');
					}
					jQuery('.filtersContainer.tableAttached').css('height', 56);
					jQuery('.filtersContainer.tableAttached .row').css('height', 52);
					var maxWidth = width / totalFilters - 16 > 400 ? 400 : width / totalFilters - 16;
					jQuery('.filtersContainer .currentFilters').css('maxWidth', maxWidth);
					jQuery('.filtersContainer .currentFilters .filterEdit').css('maxWidth', maxWidth);
					jQuery('.smartTable').floatThead('reflow');
					// latest version of floatThead is off by 2px in their calculation of width
					setTimeout(function() {
						var tbWidth = jQuery('.floatThead-container').width();
						jQuery('.floatThead-container').width(tbWidth - 2);
					}, 0);
					
					scope.$emit('resolutionValueChanged');
				}

				function init() {
					var gridLoaded = jQuery('#' + tableName + 'BodyDiv').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('#handlebarContainer').bind('leftNavChanged', function () {
							resizeTable();
						});

						jQuery('#navigation').bind('leftNavChanged', function () {
							resizeTable();
						});						
						resizeTable();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				init();
			}
		};
	})

	.directive('closeInlineEdit', function ($document) {
		return {
			restrict: 'A',
			link: function (scope, elem, attrs) {
				var onClick = function (e) {
					var isChild = jQuery('.inlineEditDiv').has(e.target).length > 0;
					var isSelf = jQuery(e.target).hasClass('inlineEditDiv');
					var isIconChild = jQuery('.inlineEditIcon').has(e.target).length > 0;
					var isIcon = jQuery(e.target).hasClass('inlineEditIcon');
					var isButtonOnDatePicker = jQuery(e.target).parents('.picker').length > 0;
					var isDisabledButton = jQuery('#' + jQuery(e.target).parents('td').attr('id')).parents('.picker').length > 0;
					var isUiSelectChoice = jQuery(e.target).parents('.ui-select-choices-row').length > 0;
					var isInside = isChild || isSelf || isIconChild || isIcon || isButtonOnDatePicker || isDisabledButton || isUiSelectChoice;
					if (!isInside) {
						scope.$apply(attrs.closeInlineEdit);
					}
				};

				scope.$watch(attrs.isActive, function (newValue, oldValue) {
					if (newValue !== oldValue && newValue == true) {
						$document.bind('click', onClick);
					} else if (newValue !== oldValue && newValue == false) {
						$document.unbind('click', onClick);
					}
				});
			}
		};
	})

	.service('leanTableService', function ($http, $q, URLS, FIRST_VIEW, $filter, leanFilterService, excelExportService) {
		// Columns in this list will be sorted descending on first click
		var self = this;
		self.reversedSortColumns = {};
		var urlPfx = URLS.prefix;
		self.tableName = '';
		self.defaultSort = [];
		self.alternateUrl = '';

		return {
			getPage: getPage,
			getExcel: getExcel,
			getExcelNew: getExcelNew,
			getConfig: getConfig,
			updateConfig: updateConfig,
			convertSortToBackend: convertSortToBackend,
			convertSortToFrontend: convertSortToFrontend,
			getDefaultSort: getDefaultSort,
			setDefaultSort: setDefaultSort,
			setTableName: setTableName,
			getTableName: getTableName,
			setReportSettingsName: setReportSettingsName,
			setReversedSortColumns: setReversedSortColumns,
			addColumnToReversedSortColumns: addColumnToReversedSortColumns,
			setInline: setInline,
			setAlternateUrl: setAlternateUrl,
			deleteInline: deleteInline,
			isReverseSort: isReverseSort,
			getResponsibleCategories: getResponsibleCategories,
			getCommentHistory: getCommentHistory,
			getYtdProjectSavings: getYtdProjectSavings,
			getLateDeliveryCauses: getLateDeliveryCauses,
			getPoStatusCategories: getPoStatusCategories,
			showMessageForOutofSyncSites: showMessageForOutofSyncSites,
			getRiskScores: getRiskScores,
			getEmailPreview: getEmailPreview
		};

		function addFilterQueryParams(url) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1)
				qParams = '?' + parts[1];

			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}

		function buildUrl(start, number, sort, extraParams, doCount) {
			var factories = leanFilterService.getFactoryList();
			var url = urlPfx + factories + '/' + self.tableName + 'Report';
			if (self.alternateUrl && self.alternateUrl.length) url = self.alternateUrl;
			var parts = url.split('?');
			url = parts[0];
			var qParams = '';

			if (parts.length >= 1)
				qParams = '?' + (parts[1] == undefined ? '' : parts[1]);

			if (number) {
				qParams = appendQueryParam(qParams, 'start', start);
				qParams = appendQueryParam(qParams, 'limit', number);
			}
			if (sort) {
				var sorter = convertSortToBackend(sort);
				if (sorter) {
					qParams = appendQueryParam(qParams, 'sort', encodeURI(JSON.stringify(sorter)));
				}
			}
			if (extraParams) {
				for (var i = 0; i < extraParams.length; i++) {
					qParams = appendQueryParam(qParams, extraParams[i].name, extraParams[i].value);
				}
			}
			if (doCount) {
				qParams = appendQueryParam(qParams, 'count', true);
			}
			url = addFilterQueryParams(url + qParams);

			return url;
		}

		function setInline(value, rowNdx, connector, subtype, factoryNdx) {
			factoryNdx = factoryNdx || globalConfig.factory.id;
			var url = urlPfx + factoryNdx + '/Comment/ConnectsTo/' +
				connector + '/val/' + rowNdx + '/subval/' + subtype + '/';
			return $http.put(URLS.host + url, value, {
				ignoreLoadingBar: true
			})
				.then(setInlineComplete)
				.catch(setInlineFailed);

			function setInlineComplete(response) {
				return response.data;
			}

			function setInlineFailed(error) {
				if (error && error.status && error.status === 408) {
					return {
						'error': 'Request timed out, please try again'
					};
				} else if (error && error.data && error.data.error){
					return error.data;
				} else {
					return {
						'error': 'Unexpected Server Error'
					};
				}
			}
		}

		function getResponsibleCategories(factoryNdx) {
			factoryNdx = factoryNdx || globalConfig.factory.id;
			var url = urlPfx + factoryNdx + '/Comment/ResponsibleCategories';
			return $http.get(URLS.host + url)
				.then(getResponsibleCategoriesComplete)
				.catch(getResponsibleCategoriesFailed);

			function getResponsibleCategoriesComplete(response) {
				if (!response.data || !response.data.length) return [];
				return response.data;
			}

			function getResponsibleCategoriesFailed(error) {
				return [];
			}
		}

		function getLateDeliveryCauses(factoryNdx) {
			var url = String.format(URLS.lateDeliveryCausesByLiability, factoryNdx);
			return $http.get(URLS.host + url)
				.then(getLateDeliveryIssuesComplete)
				.catch(getLateDeliveryIssuesFailed);

			function getLateDeliveryIssuesComplete(response) {
				if (!response.data || !response.data.length) return [];
				return _.sortBy(response.data, ['description']);
			}

			function getLateDeliveryIssuesFailed(error) {
				return [];
			}
		}

		function getPoStatusCategories() {
			return $http.get(URLS.host + String.format(URLS.poStatusCategories, globalConfig.customer.id))
				.then(getPoStatusCategoriesComplete)
				.catch(getPoStatusCategoriesFailed);

			function getPoStatusCategoriesComplete(response) {
				if (!response.data || !response.data.length) return [];
				return _.sortBy(response.data, function (val) {
					return val['description'].toLowerCase();
				});
			}

			function getPoStatusCategoriesFailed(error) {
				return [];
			}
		}

		function getPromiseComplete(response) {
			return response;
		}

		function getPromiseFailed(error) {
			return error;
		}

		function getPromiseWithCancel(url){
			var canceller = $q.defer();
			var cancel = function () {
				canceller.promise.isUserCancelled = true;
				canceller.resolve('Cancelled');
			};
			var promise = $http.get(URLS.host + url, {
				timeout: canceller.promise
			})
				.then(getPromiseComplete)
				.catch(getPromiseFailed);

			return {
				promise: promise,
				cancel: cancel
			};
		}

		function getCommentHistory(commentNdx, table, siteId, type, lateDeliveryIssueCommentNdx, firstPoEcdNdx) {
			if (!siteId) siteId = globalConfig.factory.id;
			if (!commentNdx) {
				commentNdx = 0;
			}
			var url = urlPfx + siteId + '/Comment/History/' + commentNdx + '?table=' + table;
			if (type === 'poComment' || type === 'lateDeliveryDescription') {
				url += (lateDeliveryIssueCommentNdx ? '&lateDeliveryComment=' + lateDeliveryIssueCommentNdx : '');
			}
			return getPromiseWithCancel(url);
		}

		function getRiskScores(itemNdx, siteId) {
			if (!siteId) siteId = globalConfig.factory.id;
			if (!itemNdx) {
				itemNdx = 0;
			}

			var url = urlPfx + siteId + '/RiskScore/Item/' + itemNdx + '?factoryNdx=' + siteId;
			return getPromiseWithCancel(url);
		}

		function getEmailPreview(messageId) {
			var url = '2/EmailMessageReport/Message/messageId/' + messageId;
			return getPromiseWithCancel(url);
		}

		function getYtdProjectSavings(projectId, siteId) {
			if (!siteId) siteId = globalConfig.factory.id;

			var url = String.format(URLS.projectYtdSavings, siteId, projectId);
			return getPromiseWithCancel(url);
		}

		function deleteInline(id) {
			var url = urlPfx + globalConfig.factory.id + '/Comment/' + id;
			return $http.delete(URLS.host + url, {
				ignoreLoadingBar: true
			})
				.then(deleteInlineComplete)
				.catch(deleteInlineFailed);

			function deleteInlineComplete(response) {
				return response.data;
			}

			function deleteInlineFailed(error) {
				if (error && error.status && error.status === 408) {
					return {
						'error': 'Request timed out, please try again'
					};
				} else if (error && error.data && error.data.error){
					return error.data;
				} else {
					return {
						'error': 'Unexpected Server Error'
					};
				}
			}
		}

		function getPage(start, number, params, extraParams, noPaging) {
			var pageUrl;
			if (noPaging) {
				pageUrl = buildUrl(null, null, params.sort, extraParams, false);
				return $http.get(URLS.host + pageUrl).then(function (result) {
					var list = [];
					list.push(result.data);
					return list;
				});
			} else {
				pageUrl = buildUrl(start, number, params.sort, extraParams, false);
				var countUrl = buildUrl(null, null, null, extraParams, true);

				var pagePromise = $http.get(URLS.host + pageUrl);
				var countPromise = $http.get(URLS.host + countUrl);

				return $q.all([pagePromise, countPromise]).then(function (result) {
					var tmp = [];
					angular.forEach(result, function (response) {
						tmp.push(response.data);
					});
					return tmp;
				});
			}
		}

		function getExcel(params, modalInstance, extraParams) {
			var url = urlPfx + leanFilterService.getFactoryList() + '/ExcelReports/' + self.tableName;
			var sorter = convertSortToBackend(params.sort);
			if (sorter) {
				url += '?sort=' + JSON.stringify(sorter);
			}

			if (extraParams) {
				for (var i = 0; i < extraParams.length; i++) {
					url = appendQueryParam(url, extraParams[i].name, extraParams[i].value);
				}
			}
			url = encodeURI(url);
			var data = {};
			var msFilters = leanFilterService.getQueryParam(true);
			for (var i = 0; i < msFilters.length; i++) {
				data[msFilters[i].key] = msFilters[i].value.toString();
			}
			jQuery.fileDownload(URLS.host + url, {
				httpMethod: 'POST',
				data: data,
				encodeHTMLEntities: false,
				successCallback: function (url) {
					if (modalInstance)
						modalInstance.close();
				},
				failCallback: function (responseHtml, url) {
					if (modalInstance)
						modalInstance.close();
				}
			});
		}

		function getExcelNew(params, extraParams, modalScope, $scope, args) {
			var url = URLS.host + urlPfx + leanFilterService.getFactoryList() + '/ExcelReports/' + self.tableName;
			var sorter = convertSortToBackend(params.sort);
			if (sorter) {
				url += '?sort=' + JSON.stringify(sorter);
			}

			if (extraParams) {
				for (var i = 0; i < extraParams.length; i++) {
					url = appendQueryParam(url, extraParams[i].name, extraParams[i].value);
				}
			}
			if (args && args.type === 'visibleOnly') {
				var columns = $scope.columns.filter(function(col) { return col.active;}).map(function(col) { return col.id; });
				if (!columns) columns = [];
				if ($scope.activeDoubleHeaderColumns && $scope.activeDoubleHeaderColumns.length) {
					$scope.activeDoubleHeaderColumns.map(function(col) {
						$scope.doubleHeadersBottom.forEach(function(colBottom) {
							columns.push(colBottom.id + col.id);
						});
					});
				}
				url = appendQueryParam(url, 'columns', columns);
			}
			url = encodeURI(url);
			url = appendQueryParam(url, 'excelRequest', true);
			url = leanFilterService.addFilterQueryParams(url);
			return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), url, modalScope);
		}

		function getDefaultSort() {
			return self.defaultSort;
		}

		function getConfig(useCustomer) {
			var url = URLS.host + urlPfx + globalConfig.factory.id + '/ReportSettings/' + self.reportSettingsName;
			if (useCustomer) url += '?type=customer';
			return $http.get(url)
				.then(getConfigComplete)
				.catch(getConfigFailed);

			function getConfigComplete(response) {
				if (response.status === 204) {
					// No config yet, create a new empty config object
					response.data = {};
					response.data.filters = leanFilterService.getDefaultFilters();
					response.data.recordsPerPage = 50;
					response.data.search = '';
					response.data.columns = [];
					response.data.defaultConfig = true;
				}
				if (!response.data.sorters || response.data.sorters.length === 0) {
					response.data.sorters = getDefaultSort();
				}
				return response.data;
			}

			function getConfigFailed(error) {
				return undefined;
			}
		}

		function updateConfig(config, useCustomer) {
			config.userModified = true;

			// don't send defaultConfig to backend
			var strippedConfig = {};
			for (var key in config) {
				if (key !== 'defaultConfig' && key !== 'reportSettingsName') {
					strippedConfig[key] = config[key];
				}
			}
			strippedConfig.config = strippedConfig.config || {};
			strippedConfig.reportName = strippedConfig.reportName || self.reportSettingsName;
			strippedConfig.baseReportName = strippedConfig.baseReportName || self.reportSettingsName;
			strippedConfig.viewType = strippedConfig.viewType || FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[strippedConfig.baseReportName] || '';
			var url = URLS.host + urlPfx + globalConfig.factory.id + '/ReportSettings/' + self.reportSettingsName;
			if (useCustomer) url += '?type=customer';

			return $http.put(url, strippedConfig)
				.then(updateConfigComplete)
				.catch(updateConfigFailed);

			function updateConfigComplete(response) {
				return response.data;
			}

			function updateConfigFailed(error) {
				return undefined;
			}
		}

		// Convert to backend format.
		// Input: json object with 'predicate' and 'reverse' fields (smart table convention)
		// Output: json object with 'property' and 'direction' fields (backend convention)
		function convertSortToBackend(frontendSort) {
			var sorter = null;
			if (frontendSort && frontendSort.predicate) {
				var reversedDefaultSortOrder = (self.reversedSortColumns[frontendSort.predicate] === true);
				var doReverse = (frontendSort.reverse ? !reversedDefaultSortOrder : reversedDefaultSortOrder);
				sorter = [{
					'property': frontendSort.predicate,
					'direction': (doReverse ? 'DESC' : 'ASC')
				}];
			}
			return sorter;
		}

		// Convert to frontend format.
		// Input: json object with 'property' and 'direction' fields (backend convention)
		// Output: json object with 'predicate' and 'reverse' fields (smart table convention)
		function convertSortToFrontend(backendSort) {
			var sorter = {};
			if (backendSort && backendSort.length && backendSort[0] && backendSort[0].property) {
				var predicate = backendSort[0].property;
				var reverse = false;
				if (self.reversedSortColumns[predicate]) {
					reverse = (backendSort[0].direction === 'ASC');
				} else {
					reverse = (backendSort[0].direction === 'DESC');
				}
				sorter = {
					'predicate': predicate,
					'reverse': reverse
				};
			}
			return sorter;
		}

		function setDefaultSort(newDefaultSort) {
			self.defaultSort = newDefaultSort;
		}

		function setTableName(newTableName) {
			self.tableName = newTableName;
		}

		function getTableName() {
			return self.tableName;
		}

		function setReportSettingsName(reportSettingsName) {
			globalReportName = reportSettingsName;
			self.reportSettingsName = reportSettingsName;
		}

		function setReversedSortColumns(newRsc) {
			self.reversedSortColumns = newRsc;
		}

		function addColumnToReversedSortColumns(column) {
			self.reversedSortColumns[column] = true;
		}

		function isReverseSort(col) {
			return self.reversedSortColumns[col];
		}

		function setAlternateUrl(alt) {
			self.alternateUrl = alt;
		}

		function showMessageForOutofSyncSites(sitesOutOfSync, scope) {
			var message = '';
			if (sitesOutOfSync) {
				var sites = _.keys(sitesOutOfSync);
				angular.forEach(sites, function(site) {
					message += globalConfig.user.authFacts[site].alias + ', ';
				});
				if (message !== '') {
					message = message.substr(0, message.length - 2);
					message += (sites.length == 1 ? ' is ': ' are ') + 'out of Sync';
					scope.$emit('toast', {'message': message, 'success': false});
				}
			}
		}
	});
